export const links = [
  {
    id: 1,
    text: "Home Services",
    url: "/",
    dropdown: true,
  },
  {
    id: 2,
    text: "Commercial Services",
    url: "/trading",
    dropdown: true,
  },
  /*  {
        id: 3,
        text: 'Boiler Cover',
        url: '/market',
        dropdown: false,
    }, */
  {
    id: 3,
    text: "Company",
    url: "/todo",
    dropdown: true,
  },
  /* {
        id: 5,
        text: 'Company',
        url:'/company',
        dropdown: false,
    } */
];

export const footerLinks = [
  {
    id: 1,
    text: "FAQs",
    url: "/faq",
  },
  {
    id: 2,
    text: "Contact us",
    url: "/contact",
  },
  {
    id: 3,
    text: "Careers",
    url: "/careers",
  },
  {
    id: 4,
    text: "AquaHeat Trustpilot",
    url: "https://uk.trustpilot.com/review/aquaheatplumbing.co.uk?utm_medium=trustbox&utm_source=Carousel",
  },
];

export const policyLinks = [
  {
    id: 1,
    text: "Cookies Policy",
    url: "/cookies",
  },
  {
    id: 2,
    text: "Privacy Policy",
    url: "/privacy",
  },
  {
    id: 3,
    text: "Terms & Conditions",
    url: "/terms",
  },
  {
    id: 4,
    text: "Sitemap",
    url: "sitemap",
  },
];
